import { FormFieldWidth, VariableInput, VariableInputType } from "@swivl-mono/ui";
import React from "react";

import VarsModel from "../../Models/Variables/VarsModel.Model";

export interface TagInputTag {
  id: string;
  display: string;
}

export enum TagInputType {
  Normal = "tagInputNormal",
  SingleLine = "tagInputSingleLine",
  Bubble = "tagInputBubble",
  NoBorder = "tagInputNoBorder"
}

interface InputProps {
  value?: string;

  overrideVariables?: TagInputTag[];
  mergeVariables?: TagInputTag[];
  type?: TagInputType;
  name?: string;
  disabled?: boolean;
  readOnly?: boolean;

  placeholder?: string;
  id?: string;
  label?: string;
  helperText?: string;
  error?: string;
  required?: boolean;
  autoFocus?: boolean;
  className?: string;
  containerClassName?: string;
  width?: FormFieldWidth;
  maxLength?: number;
  onMaxLengthExceeded?(): void;
  onLengthChange?(length: number): void;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onSet?(value: React.SetStateAction<string>, name?: string): void;
  onReturnPressed?(): void;

  onBlur?(): void;
  onFocus?(): void;
}

const TAG_TO_VARIABLE_TYPE: Record<TagInputType, VariableInputType> = {
  [TagInputType.Normal]: VariableInputType.Normal,
  [TagInputType.SingleLine]: VariableInputType.SingleLine,
  [TagInputType.Bubble]: VariableInputType.Bubble,
  [TagInputType.NoBorder]: VariableInputType.NoBorder
};

export function TagInput(props: InputProps) {
  const {
    value,
    type,
    name,
    disabled,
    readOnly,
    placeholder,
    id,
    label,
    helperText,
    error,
    required,
    autoFocus,
    className,
    containerClassName,
    width,
    maxLength,
    onMaxLengthExceeded,
    onLengthChange,
    onChange,
    onSet,
    onReturnPressed,
    onBlur,
    onFocus
  } = props;

  const handleChange = (newValue: string, fieldName?: string): void => {
    if (onChange) {
      onChange({ target: { value: newValue, name: fieldName } } as unknown as React.ChangeEvent<HTMLInputElement>);
    }
    if (onSet) {
      onSet(newValue, name);
    }
  };

  return (
    <VariableInput
      value={value}
      variables={VarsModel.getTagInputVariables()}
      type={TAG_TO_VARIABLE_TYPE[type ?? TagInputType.Normal]}
      name={name}
      disabled={disabled}
      readOnly={readOnly}
      placeholder={placeholder}
      id={id}
      label={label}
      helperText={helperText}
      error={error}
      required={required}
      autoFocus={autoFocus}
      className={className}
      containerClassName={containerClassName}
      width={width}
      maxLength={maxLength}
      onMaxLengthExceeded={onMaxLengthExceeded}
      onLengthChange={onLengthChange}
      onChange={handleChange}
      onReturnPressed={onReturnPressed}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
}
